
<div class="input-group">
    <input #DisplayNameInput type="text" class="form-control" [value]="FileAttachment.DisplayName" disabled />
    <button type="button"
            class="btn btn-primary"
            (click)="DownloadFile()"
            *ngIf="!EditMode">
        Download
    </button>
    <button type="button"
            class="btn btn-warning"
            (click)="RenameClick()"
            *ngIf="EditMode">
        {{DisplayNameInput.disabled ? 'Rename' : 'Save'}}
    </button>
    <button type="button"
            class="btn btn-danger"
            *ngIf="EditMode"
            [popoverTitle]="'Are you sure?'"
            [ngbPopover]="ConfirmPopoverContent"
            [triggers]="'manual'"
            [autoClose]="'outside'"
            #ConfirmDelete="ngbPopover"
            (click)="ConfirmDelete.open()">
        Delete
    </button>
    <ng-template #ConfirmPopoverContent>
        <div class="d-flex gap-2">
            <button type="button" class="btn btn-danger" (click)="DeleteFile()">Yes</button>
            <button type="button" class="btn btn-secondary" (click)="CloseConfirmDelete()">No</button>
        </div>
    </ng-template>
</div>